import { ICurrentUser } from './CurrentUser.ts';

/** The password was right, but an Active HCP still has to enter the code texted to their mobile. */
export interface ISignInChallenge {
    smsCodeRequired: true;
    signInToken: string;
    mobileLast4: string;
}

export const isSignInChallenge = (answer: ICurrentUser | ISignInChallenge): answer is ISignInChallenge =>
    (answer as ISignInChallenge).smsCodeRequired === true;
